// extracted by mini-css-extract-plugin
export default {"list":"ContactList_list__csErn"};